"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/PhoneMFA/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');

var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _AuthFrame = require('web/components/AuthFrame');
var _components = require('web/screens/Signup/components');
var _CodeForm = require('web/screens/Login/MFA/CodeForm'); var _CodeForm2 = _interopRequireDefault(_CodeForm);












const intro = (phone) => _react2.default.createElement(_react2.default.Fragment, null, "Enter the 6-digit code we texted to "       ,  phone , ".")

const PhoneMFASection = ({
  maskedPhone,
  onBack,
  onResend,
  onVerify,
  phoneOnAnotherAccount,
  onContinueNewAccount,
}) => (
  _react2.default.createElement(_react2.default.Fragment, null
    , _react2.default.createElement(_components.SignupStepHeader, { title: "Verify your phone"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}} )
    ,  phoneOnAnotherAccount
      ? (
          // A note, not an error: carrying on is a normal choice.
          _react2.default.createElement('div', { className: "auth-stack", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
            , _react2.default.createElement('p', { className: "auth-note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
              , _react2.default.createElement(_AuthFrame.InfoIcon, { className: "auth-note--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}} )
              , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}, "This number is already on another BloomText account. Sign in to it instead, or continue creating a new account."

              )
            )
            , _react2.default.createElement('div', { className: "auth-callout--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
              , _react2.default.createElement(_reactrouterdom.Link, { to: _routes2.default.LOGIN.ROOT, className: "auth-chip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}, "Sign in to it instead"

              )
              , _react2.default.createElement('button', { type: "button", className: "auth-chip", onClick: onContinueNewAccount, __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}, "Continue creating a new account"

              )
            )
          )
        )
      : (
          _react2.default.createElement(_CodeForm2.default, {
            maskedPhone: maskedPhone,
            onSubmit: onVerify,
            onResend: onResend,
            onBack: onBack,
            intro: intro, __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
          )
        )
  )
)

exports. default = PhoneMFASection
